import React from 'react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import PillTextBox, { PillColorTheme } from 'components/Common/PillTextBox'
import { AppSettings } from 'components/AppTools/AppToolsPanel/AppToolBlock/AppSettings/AppSettings.component'

interface IAppPillBoxAndSetting {
  isToolDisconnecting: boolean
  isConnected?: boolean
  handleDisconnect: () => void
}

export const AppPillBoxAndSetting: FC<IAppPillBoxAndSetting> = ({
  isToolDisconnecting,
  isConnected,
  handleDisconnect,
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-row gap-4">
      {!isToolDisconnecting && (
        <PillTextBox
          colorTheme={isConnected ? PillColorTheme.SUCCESS : PillColorTheme.ERROR}
          size="small"
        >
          {isConnected ? t('tools.status.connected') : t('tools.status.notConnected')}
        </PillTextBox>
      )}
      {isConnected && (
        <div>
          <AppSettings handleDisconnect={handleDisconnect} disabled={!isConnected} />
        </div>
      )}
    </div>
  )
}
